import { clsx } from "clsx";
import { type CSSProperties, type FC } from "react";

import { TooltipController } from "../../overlays/components/OverlayControllers.js";

export type IOptionObject = Record<string, string>;

export interface IOption {
  isSelected: boolean;
  labelKey: string;
  valueKey: string;
  item: IOptionObject;
  style?: CSSProperties;
  selectValue: (item: IOptionObject) => void;
  classNames?: string;
}

const Option: FC<IOption> = (props) => {
  const { item, isSelected, valueKey, labelKey, selectValue, style } = props;

  const cssClasses = props.classNames != null ? props.classNames : clsx("checkbox", { selected: isSelected });

  return (
    <li style={style} key={item[valueKey]} onClick={() => selectValue(item)}>
      <div className={cssClasses}>
        <input
          type="checkbox"
          id={"checkbox-" + item[valueKey]}
          name={"checkbox-" + item[valueKey]}
          checked={isSelected}
          value={isSelected ? 1 : 0}
        />
        <TooltipController content={item[valueKey]}>
          {(tooltipTriggerProps) => (
            <label
              htmlFor={"checkbox-" + item[valueKey]}
              onClick={(e) => e.preventDefault()}
              onPointerEnter={tooltipTriggerProps.onPointerEnter}
              onPointerLeave={tooltipTriggerProps.onPointerLeave}
              ref={tooltipTriggerProps.ref}
            >
              {item[labelKey]}
            </label>
          )}
        </TooltipController>
      </div>
    </li>
  );
};

export default Option;
